/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************!*\
  !*** ./js/sections/global.js ***!
  \*******************************/
document.addEventListener('DOMContentLoaded', () => {
  var requestPricingBtn = document.getElementById('request_pricing');
  var pricingPopupContainer = document.querySelector('.pricing_popup_container');
  requestPricingBtn.addEventListener('click', e => {
    e.stopPropagation();
    pricingPopupContainer.style.display = 'block';
    document.querySelector('body').classList.add('pricing_popup_open');
    document.querySelector('.js-toolbar-icon.active').classList.remove('active');
    document.querySelector('.detail-share-social').classList.add('pricing_popup_open');
  });
  pricingPopupContainer.querySelector('.close_popup').addEventListener('click', () => {
    pricingPopupContainer.style.display = 'none';
    document.querySelector('body').classList.remove('pricing_popup_open');
    document.querySelector('.js-toolbar-icon').classList.add('active');
    document.querySelector('.detail-share-social').classList.remove('pricing_popup_open');
  });
});
/******/ })()
;